import React from "react";

const AGE_OPTIONS = [
  { value: "", label: "All Ages", id: "all" },
  { value: "0,8", label: "0-8", id: "0-8" },
  { value: "9,16", label: "9-16", id: "9-16" },
  { value: "17,24", label: "17-24", id: "17-24" },
  { value: "25,55", label: "25-55", id: "25-55" },
  { value: "56,65", label: "56-65", id: "56-65" },
  { value: "66,100", label: "65+", id: "65+" },
];

function AgeFilter({ value, onChange }) {
  return (
    <form className="search-input-wrap age-filter-form">
      <div className="filter-section-heading">
        <span className="label-no-transform">Age Group</span>
      </div>
      <div className="age-radio" name="age_range">
        {AGE_OPTIONS.map((opt) => (
          <span key={opt.id} className="radio-option">
            <input
              type="radio"
              name="age"
              value={opt.value}
              id={opt.id}
              checked={(value || "") === opt.value}
              onChange={() => onChange(opt.value || null)}
            />
            <label className="age-group-radio-btn" htmlFor={opt.id}>
              {opt.label}
            </label>
          </span>
        ))}
      </div>
    </form>
  );
}

export default AgeFilter;
